import React, {useMemo} from "react";
import {sumBy} from "lodash";
import {numberWithCommas} from "../../utils/StringFormat";
import {StatisticsLabel} from "../components/StatisticsLabel";

export const OrdersStatisticsLabel = ({orders = []}) => {
    const totalOrdersPrice = useMemo(
        () =>
            sumBy(
                orders,
                order => (Number(order.offeredPrice) || 0) + (order.deliveryPrice - 0 || 0) + (order.tip || 0)
            ),
        [orders]
    );

    return (
        <StatisticsLabel
            title={
                <span>
                    סה״כ הזמנות לתקופה:
                    <span>{numberWithCommas(totalOrdersPrice?.toFixed(0))}</span>₪
                </span>
            }
        />
    );
};
